uniform vec2 resolution;
uniform float time;
varying vec2 vUv;

// Lots nore different noises from this package: http://stack.gl/packages/#hughsk/glsl-noise
#pragma glslify: snoise3 = require(glsl-noise/simplex/3d) 
#pragma glslify: dither = require(glsl-dither/4x4) 

vec3 interpolate3ColorsDiscrete(float v, vec3 color1, vec3 color2, vec3 color3, float smoothFactor) {
    vec3 result;

    // Normalize v to be between 0 and 1
    v = clamp(v, 0.0, 1.0);

    // Clamp smoothFactor to be between 0 and 1
    smoothFactor = clamp(smoothFactor, 0.0, 1.0);

    // Calculate segment length
    float segmentLength = 1.0 / 2.0;

    if (v < 0.33) {
        float t = smoothstep(0.33 - smoothFactor * segmentLength, 0.33, v);
        result = mix(color1, color2, t);
    } else if (v < 0.66) {
        float t = smoothstep(0.66 - smoothFactor * segmentLength, 0.66, v);
        result = mix(color2, color3, t);
    } else {
        float t = smoothstep(1.0 - smoothFactor * segmentLength, 1.0, v);
        result = mix(color3, color3, t); // Final color stays the same
    }

    return result;
}

vec3 interpolate4ColorsDiscrete(float v, vec3 color1, vec3 color2, vec3 color3, vec3 color4, float smoothFactor) {
    vec3 result;

    // Normalize v to be between 0 and 1
    v = clamp(v, 0.0, 1.0);

    // Clamp smoothFactor to be between 0 and 1
    smoothFactor = clamp(smoothFactor, 0.0, 1.0);

    // Calculate segment length
    float segmentLength = 1.0 / 3.0;

    if (v < 0.25) {
        float t = smoothstep(0.25 - smoothFactor * segmentLength, 0.25, v);
        result = mix(color1, color2, t);
    } else if (v < 0.5) {
        float t = smoothstep(0.5 - smoothFactor * segmentLength, 0.5, v);
        result = mix(color2, color3, t);
    } else if (v < 0.75) {
        float t = smoothstep(0.75 - smoothFactor * segmentLength, 0.75, v);
        result = mix(color3, color4, t);
    } else {
        float t = smoothstep(1.0 - smoothFactor * segmentLength, 1.0, v);
        result = mix(color4, color4, t); // Final color stays the same
    }

    return result;
}

vec3 interpolate5ColorsDiscrete(float v, vec3 color1, vec3 color2, vec3 color3, vec3 color4, vec3 color5, float smoothFactor) {
    vec3 result;

    // Normalize v to be between 0 and 1
    v = clamp(v, 0.0, 1.0);

    // Clamp smoothFactor to be between 0 and 1
    smoothFactor = clamp(smoothFactor, 0.0, 1.0);

    // Calculate segment length
    float segmentLength = 1.0 / 4.0;

    if (v < 0.2) {
        float t = smoothstep(0.2 - smoothFactor * segmentLength, 0.2, v);
        result = mix(color1, color2, t);
    } else if (v < 0.4) {
        float t = smoothstep(0.4 - smoothFactor * segmentLength, 0.4, v);
        result = mix(color2, color3, t);
    } else if (v < 0.6) {
        float t = smoothstep(0.6 - smoothFactor * segmentLength, 0.6, v);
        result = mix(color3, color4, t);
    } else if (v < 0.8) {
        float t = smoothstep(0.8 - smoothFactor * segmentLength, 0.8, v);
        result = mix(color4, color5, t);
    } else {
        float t = smoothstep(1.0 - smoothFactor * segmentLength, 1.0, v);
        result = mix(color5, color5, t); // Final color stays the same
    }

    return result;
}



vec3 interpolate6ColorsDiscrete(float v, vec3 color1, vec3 color2, vec3 color3, vec3 color4, vec3 color5, vec3 color6, float smoothFactor) {
    vec3 result;

    // Normalize v to be between 0 and 1
    v = clamp(v, 0.0, 1.0);

    // Clamp smoothFactor to be between 0 and 1
    smoothFactor = clamp(smoothFactor, 0.0, 1.0);

    // Determine the current segment and use smoothstep for a smooth transition between segments
    float segmentLength = 1.0 / 5.0;

    if (v < 0.2) {
        float t = smoothstep(0.2 - smoothFactor * segmentLength, 0.2, v);
        result = mix(color1, color2, t);
    } else if (v < 0.4) {
        float t = smoothstep(0.4 - smoothFactor * segmentLength, 0.4, v);
        result = mix(color2, color3, t);
    } else if (v < 0.6) {
        float t = smoothstep(0.6 - smoothFactor * segmentLength, 0.6, v);
        result = mix(color3, color4, t);
    } else if (v < 0.8) {
        float t = smoothstep(0.8 - smoothFactor * segmentLength, 0.8, v);
        result = mix(color4, color5, t);
    } else {
        float t = smoothstep(1.0 - smoothFactor * segmentLength, 1.0, v);
        result = mix(color5, color6, t);
    }

    return result;
}


void main() {
    // vec2 st = gl_FragCoord.xy / resolution.xy;
    // gl_FragColor = vec4(st.x, st.y, 1.0, 1.0);
    vec2 uv = vUv;
    uv -= 0.5;
    vec2 st = uv * resolution;
    st.y += time * 0.05;

    float v = (snoise3(vec3(st * 0.002, time * 0.00005)) + 1.0) * 0.5;

    vec3 color1 = vec3(1.0, 0.0, 0.88);
    vec3 color2 = vec3(0.0, 0.38, 1.0);
    vec3 color3 = vec3(0.04, 0.7, 0.9);
    vec3 color4 = vec3(0.0, 1.0, 0.58);
    vec3 color5 = vec3(1.0, 0.93, 0.0);
    vec3 color6 = vec3(1.0, 0.0, 0.15);

    // boost v to get it to accodate the last color better
    v *= 1.3;

    //gl_FragColor = vec4(interpolate3ColorsDiscrete(v, color1, color2, color3, 0.01), 1.0);
    //gl_FragColor = vec4(interpolate4ColorsDiscrete(v, color1, color2, color3, color4, 0.01), 1.0);
    //gl_FragColor = vec4(interpolate5ColorsDiscrete(v, color1, color2, color3, color4, color5, 0.01), 1.0);
    gl_FragColor = vec4(interpolate6ColorsDiscrete(v, color1, color2, color3, color4, color5, color6, 0.01), 1.0);

    // gl_FragColor = dither(st*0., gl_FragColor);

}